export default __webpack_public_path__ + "static/media/Pyronometer_Blue.f9f19c3b.svg";